/* NEWLUNA 3.0 "Find your glow": a three-step guide that ranks products by
   what they are made for (focus), how long they take (time) and their kind
   (skincare or beauty technology). No personal data is stored or sent. */
(function () {
  'use strict';
  var LABELS = {
    focus: { glow: 'a fresh, hydrated-looking glow', tone: 'a more even-looking tone', clear: 'blemish care', led: 'at-home light sessions', scalp: 'scalp and hair care', tools: 'clean, cared-for tools' },
    time: { quick: 'a few minutes', session: 'a relaxing session', overnight: 'overnight care' },
    type: { skincare: 'skincare', tech: 'beauty technology', both: 'a mix of both' }
  };
  var STEPS = ['focus', 'time', 'type'];

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function list(v) { return Array.isArray(v) ? v : (v ? [v] : []); }

  function init(root) {
    if (root.dataset.quizReady) return;
    root.dataset.quizReady = '1';
    var data = [];
    try { data = JSON.parse(root.querySelector('[data-quiz-data]').textContent); } catch (e) { return; }
    var form = root.querySelector('[data-quiz-form]');
    var result = root.querySelector('[data-quiz-result]');
    var picks = root.querySelector('[data-quiz-picks]');
    var summary = root.querySelector('[data-quiz-summary]');
    var stepLabel = root.querySelector('[data-quiz-step]');
    var bar = root.querySelector('[data-quiz-bar]');
    var back = root.querySelector('[data-quiz-back]');
    var next = root.querySelector('[data-quiz-next]');
    var sets = STEPS.map(function (k) { return root.querySelector('[data-q="' + k + '"]'); });
    var step = 0;
    var answers = {};

    function show(i) {
      step = i;
      sets.forEach(function (fs, j) {
        fs.hidden = j !== i;
        fs.classList.toggle('is-active', j === i);
      });
      stepLabel.textContent = 'Question ' + (i + 1) + ' of ' + STEPS.length;
      bar.style.transform = 'scaleX(' + ((i + 1) / STEPS.length) + ')';
      back.hidden = i === 0;
      next.textContent = i === STEPS.length - 1 ? 'See my suggestions' : 'Next';
      next.disabled = !answers[STEPS[i]];
    }

    form.addEventListener('change', function (e) {
      var inp = e.target;
      if (!inp || inp.type !== 'radio') return;
      answers[inp.name] = inp.value;
      next.disabled = false;
    });
    back.addEventListener('click', function () { if (step > 0) show(step - 1); });
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (!answers[STEPS[step]]) return;
      if (step < STEPS.length - 1) {
        show(step + 1);
        var first = sets[step].querySelector('input:checked') || sets[step].querySelector('input');
        if (first) first.focus();
      } else {
        render();
      }
    });
    root.querySelector('[data-quiz-restart]').addEventListener('click', function () {
      answers = {};
      Array.prototype.forEach.call(form.querySelectorAll('input'), function (i) { i.checked = false; });
      result.hidden = true;
      form.hidden = false;
      show(0);
      var first = sets[0].querySelector('input');
      if (first) first.focus();
    });

    function score(p) {
      var s = 0, why = [];
      var focus = list(p.focus), time = list(p.time);
      if (focus.indexOf(answers.focus) > -1) { s += 3; why.push('Made for ' + LABELS.focus[answers.focus]); }
      if (time.indexOf(answers.time) > -1) { s += 2; why.push('Fits ' + LABELS.time[answers.time]); }
      if (answers.type === 'both' || answers.type === p.kind) { s += 1; }
      return { p: p, s: s, why: why };
    }

    function render() {
      var ranked = data.filter(function (p) { return p.available; }).map(score)
        .map(function (r, i) { r.i = i; return r; })
        .sort(function (a, b) { return (b.s - a.s) || (a.i - b.i); });
      var top = ranked.filter(function (r) { return r.s >= 3; }).slice(0, 3);
      if (top.length < 2) top = ranked.filter(function (r) { return r.s > 0; }).slice(0, 3);
      if (!top.length) top = ranked.slice(0, 2);
      summary.textContent = 'For ' + LABELS.focus[answers.focus] + ', ' + LABELS.time[answers.time] + ' and ' + LABELS.type[answers.type] + ':';
      picks.innerHTML = top.map(function (r) {
        var p = r.p;
        var action = p.variant
          ? '<button type="button" class="btn btn--sm" data-quick-add="' + p.variant + '" aria-label="Add ' + esc(p.title) + ' to bag">Add to bag</button>'
          : '<a class="btn btn--sm btn--outline" href="' + esc(p.url) + '">Choose options</a>';
        return '<li class="pick" data-product-card>' +
          '<a class="pick__img" href="' + esc(p.url) + '" tabindex="-1" aria-hidden="true">' + (p.img ? '<img src="' + esc(p.img) + '" alt="" loading="lazy" width="150" height="150">' : '') + '</a>' +
          '<div class="pick__body">' +
            '<a class="pick__name" href="' + esc(p.url) + '">' + esc(p.title) + '</a>' +
            (r.why.length ? '<p class="pick__why">' + esc(r.why.join('. ')) + '.</p>' : '') +
            (p.hint ? '<p class="pick__hint">' + esc(p.hint) + '</p>' : '') +
            '<div class="pick__foot"><span class="pick__price">' + (p.from ? 'From ' : '') + esc(p.price) + '</span>' + action + '</div>' +
          '</div></li>';
      }).join('');
      form.hidden = true;
      result.hidden = false;
      result.focus({ preventScroll: true });
      if (result.getBoundingClientRect().top < 80) result.scrollIntoView({ block: 'start', behavior: 'smooth' });
    }

    show(0);
  }

  function boot() { Array.prototype.forEach.call(document.querySelectorAll('[data-quiz]'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
